function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-width: 1px;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "f_faceshape_round_vector-2",
  "data-name": "f_faceshape_round_vector",
  className: "cls-2",
  d: "M291,302c-1.315-79.195,28.7-121.826,95-134,20.563-3.776,47.961.328,63,9,38.7,22.318,59.721,62.9,59,125,7.66-.806,9.81-0.194,15,3,10.013,29.071-10.222,45.892-23,61l-13,37c-7.481,12.351-29.3,28.871-34,38-8.934,17.343,2.217,53.774-2,69l-1,2c-7.6,14.75-25.511,22.875-36,35l-15,29-2-1c-8.5-27.217-31.1-47.77-50-65,2.824-18.96,6.971-56.825-3-73-6.961-11.291-20.535-20.231-28-32l-16-38c-5.332-5.836-12.565-7.785-17-15C274.089,337.5,261.246,300.1,291,302Z"
});

var SvgFFaceshapeRoundVector = function SvgFFaceshapeRoundVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_faceshape_round_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFFaceshapeRoundVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_faceshape_round_vector.8b28599c.svg";
export { ForwardRef as ReactComponent };